// extracted by mini-css-extract-plugin
export default {"hint":"NoneData_hint__LsqFH"};